import axios from '@raas/shared/src/utils/axios';
import {
  IMoveDocumentElement,
  IReadDocumentElement,
  IWriteDocumentElement,
  IMoveIntoDocumentElements,
} from '@raas/shared/src/types/document-element';

class DocumentElementsService {
  async get(entityId: string): Promise<IReadDocumentElement> {
    const result = await axios.get(`/document-elements/${entityId}`);
    return result.data;
  }

  delete(entityId: string): Promise<void> {
    return axios.delete(`/document-elements/${entityId}`);
  }

  async bulkDelete(entityIds: string[]): Promise<void> {
    return axios.delete(`/document-elements/bulk/delete`, { data: { entityIds } });
  }

  async create(postData: IWriteDocumentElement): Promise<string> {
    const result = await axios.post(`/document-elements`, mapToRequestBody(postData));
    return result.data;
  }

  async createDraft(entityId: string): Promise<string> {
    const result = await axios.post(`/document-elements/${entityId}/draft`);
    return result.data;
  }

  async edit(postData: IWriteDocumentElement, id: string): Promise<void> {
    return axios.put(`/document-elements/${id}`, mapToRequestBody(postData));
  }

  async moveTo(postData: IMoveDocumentElement, id: string): Promise<void> {
    return axios.post(`/document-elements/${id}/move`, mapMoveElementToRequestBody(postData));
  }

  async getOrderNumbers(id: string): Promise<number[]> {
    const result = await axios.get(`/document-elements/${id}/ordernumbers`);
    return result.data;
  }

  async moveInto(postData: IMoveIntoDocumentElements, parentEntityId: string): Promise<string[]> {
    const result = await axios.put(
      `/document-elements/${parentEntityId}/into`,
      mapMoveIntoElementsToRequestBody(postData)
    );
    return result.data;
  }
}

const mapToRequestBody = (documentElement: IWriteDocumentElement) => {
  const result = {
    id: documentElement.id,
    officialParagraphNumber: documentElement.officialParagraphNumber,
    parentEntityId: documentElement.parentEntityId,
    title: documentElement.title,
    mainBody: documentElement.mainBody,
    validFrom: documentElement.validFrom,
    validTo: documentElement.validTo,
    order: documentElement.order,
    tagIds: documentElement.tagIds,
    officialParagraphNumberHtml: documentElement.officialParagraphNumberHtml,
    titleHtml: documentElement.titleHtml,
    mainBodyHtml: documentElement.mainBodyHtml,
  };

  return result;
};

const mapMoveElementToRequestBody = (moveDocumentElement: IMoveDocumentElement) => {
  const result = {
    parentEntityId: moveDocumentElement.parentEntityId,
    order: moveDocumentElement.order,
  };

  return result;
};

const mapMoveIntoElementsToRequestBody = (moveIntoDocumentElements: IMoveIntoDocumentElements) => {
  const result = {
    ids: moveIntoDocumentElements.ids,
  };

  return result;
};

const documentElementsService = new DocumentElementsService();
export default documentElementsService;
